import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`There are three roles in an organization:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Owner:`}</strong>{` Users who manage organization members and billing.`}</li>
      <li parentName="ul"><strong parentName="li">{`Admin:`}</strong>{` Users who manage team membership and package access.`}</li>
      <li parentName="ul"><strong parentName="li">{`Member:`}</strong>{` Users who create and publish packages in the organization scope.`}</li>
    </ul>
    <><strong>On the public registry, you cannot remove the last owner from an organization.</strong> To delete an organization, {shared['contact-support'].text}.</>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Action`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}><strong parentName="th">{`Owner`}</strong></th>
          <th parentName="tr" {...{
            "align": "center"
          }}><strong parentName="th">{`Admin`}</strong></th>
          <th parentName="tr" {...{
            "align": "center"
          }}><strong parentName="th">{`Member`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Manage organization billing`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Add members to the organization`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Remove members from the organization`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Rename an organization`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Delete an organization`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Change any organization member's role`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Create teams`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Delete teams`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Add any member to any team`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Remove any member from any team`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Manage team package access`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Create and publish packages in the organization scope`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`X`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      